/**
 * FileName : const.ts
 * ProjectName : admin
 * Author : <<author>>
 * Created Date: 2024-01-04 16:08:53
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) <<year>> <<company>>. All rights reserved.
 */
import { Property } from 'csstype/index.d';

export type SemaphoresRow = {
  start?: number;
  end?: number;
  level: number;
  color: Property.BackgroundColor;
}

export interface RankRow extends SemaphoresRow {
    onlineSum: number;
    offlineSum: number;
    flag: boolean;
}

export const semaphores:SemaphoresRow[] = [
    {start: 0, end: 16, level: 1, color: '#FF6F70'},
    { start: 16, end: 32, level: 2, color: '#FDBA74' },
    {start: 128, end: 256, level: 3, color: '#77FB49'},
    {start: 32, end: 64, level: 4, color: '#40DCC9'},
    {start: 64, end: 128, level: 5, color: '#00B3F0'},
    { start: 128, end: 256, level: 6, color: '#008BF0' },
    { start: 128, end: 256, level: 7, color: '#C86FFF' },
    { start: 256, end: 99999, level: 8, color: '#C651EF' },
];

export const gisSemaphores:SemaphoresRow[] = [
    {start: 0, end: 16, level: 1, color: '#1E5824'},
    { start: 16, end: 32, level: 2, color: '#1A9F60' },
    {start: 128, end: 256, level: 3, color: '#25BC57'},
    {start: 32, end: 64, level: 4, color: '#3AC649'},
    {start: 64, end: 128, level: 5, color: '#4FD03B'},
    { start: 128, end: 256, level: 6, color: '#64DA2D' },
    { start: 128, end: 256, level: 7, color: '#79E41F' },
    { start: 256, end: 99999, level: 8, color: '#8CEC11' },
];

export const defaultMaxLevel = 7;

export const offlineSemaphore: SemaphoresRow = { level: 0, color: '#2F4056' };

export const DEVICE_TYPE = [ '0', '1' ];

export const NETWORK_MODEL_OPT = [
    {
        value: '1',
        name: 'CatM',
    },
    {
        value: '2',
        name: '2G',
    },
    {
        value: '3',
        name: '3G',
    },
    {
        value: '4',
        name: '4G',
    },
    {
        value: '5',
        name: 'NB.IoT',
    },
    {
        value: '6',
        name: 'Backhual',
    },
];

export const FILE_TYPE_LIST = [
    {
        label: 'DCU',
        value: '0',
        type: 'DCU',
    },
    {
        label: 'Meter',
        value: '1',
        type: 'Meter',
    },
    {
        label: 'Main Module',
        value: '2',
        type: 'DCU',
    },
    {
        label: 'Slave Module',
        value: '3',
        type: 'Meter',
    },
    {
        label: '7300 Module',
        value: '4',
        type: 'DCU',
    },
    // {
    //     label: 'WISUN BR',
    //     value: '7',
    //     type: 'DCU',
    // },
    // {
    //     label: 'WISUN Slave',
    //     value: '8',
    //     type: 'Meter',
    // },
]; // 墨西哥特殊需求，删除DC200 和Meter param

export const TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const DATE_FORMAT = 'YYYY-MM-DD';

export type RoleTreeRows = {
    key: string;
    value: boolean;
}

export const HOME_ROLE_OPT = [
    {
        key: 'Gis Map',
        value: false,
    },
    {
        key: 'Meter Reading Success Rate',
        value: false,
    },
    {
        key: 'Config DCU Archive',
        value: false,
    },
    {
        key: 'Device Monitoring',
        value: false,
    },
    {
        key: 'Device Event Query',
        value: false,
    },
    {
        key: 'Device Alarm Query',
        value: false,
    },
    {
        key: 'Sinamed 34 Interface Log',
        value: false,
    },
    {
        key: 'Sinamed 48 Interface Log',
        value: false,
    },
];

export const METER_COMMUNICATION_TYPE = [
    {
        label: 'labelTitleFirstRegister',
        value: '0',
    },
    {
        label: 'labelTextPush',
        value: '1',
    },
    {
        label: 'labelTextPowerOn',
        value: '2',
    },
    {
        label: 'labelTextOnDemand',
        value: '3',
    },
    {
        label: 'labelTextPowerOff',
        value: '4',
    },
    {
        label: 'labelTextColectorOffline',
        value: '5',
    },
    {
        label: 'labelTextRepeaterRegister',
        value: '6',
    },
    {
        label: 'labelTextPushIdle',
        value: '7',
    },
    {
        label: 'labelTitleRegisteredOnline',
        value: '8',
    },
    {
        label: 'labelTitleRegisteredOffline',
        value: '9',
    },
    {
        label: 'labelTextRepeaterRegisterColectorUnregisterArchive',
        value: '10',
    },
    {
        label: 'labelTextRepeaterRegisterColectorMassMeterPower',
        value: '11',
    },
    {
        label: 'labelTitlePushIdleMoreThanHours',
        value: '12',
    },
    {
        label: 'labelTitlePowerOffMoreThanHours',
        value: '13',
    },
];

export type GisRateColor = {
    rate: number;
    color: Property.BackgroundColor;
    borderColor: Property.BackgroundColor;
}

// 必须rate从大道小，不然会出现问题
export const GIS_RATE_COLOR:GisRateColor[] = [
    {
        rate: 100,
        color: '#1E5824',
        borderColor: '#118D3E',
    },
    {
        rate: 75,
        color: '#439227',
        borderColor: '#118D3E',
    },
    {
        rate: 50,
        color: '#5BB92E',
        borderColor: '#14A649',
    },
    {
        rate: 25,
        color: '#78D206',
        borderColor: '#21B757',
    },
    {
        rate: 0,
        color: '#8CEC11',
        borderColor: '#2DCE68',
    },
];

export const GIS_OFFLINE_COLOR: GisRateColor = {
    rate: -1,
    color: '#FF0000',
    borderColor: '#A10D26',
};

export const GIS_POWER_COLOR: GisRateColor = {
    rate: -2,
    color: '#ED9731',
    borderColor: '#FFD48E',
};

export const GIS_ALL_DCU_COLOR: GisRateColor = {
    rate: -3,
    color: '#22C55E',
    borderColor: 'rgba(34, 197, 94, 0.25)',
};

export const DCU_BASE_COUNT = 1000;

export const METER_TYPE_MODEL = [
    {
        label: '1S',
        value: '1S',
    },
    {
        label: '9S',
        value: '9S',
    },
    {
        label: '12S',
        value: '12S',
    },
    {
        label: '16S',
        value: '16S',
    },
];

export const MAX_EVENT_COUNT = 100;

// eslint-disable-next-line max-len
export const PUBLIC_RSA_KEY = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAt03jwJxv08538nOyNNKCnsXbzqxGBnR48QmVjg9NE2GlfLippRD9zHGTF5pwW7wE1CZknRiAJh5PSyCYzVBn80H0H6VjTRV0i2VkgSZv54ldWV9UYL2DLNq31zlDzD1g+Me4rSTtYMw9kI/Xtw8Z0a55OEElel1l4yYg0gaTX5yN5M1UgEnYUznLxaWYDeHGg6tzi2rrMz3aD7bWxcUCGNJqPq3FJfyq0UP7MrR0GHvv18D6wOO5dU+V0z5doNef2hykDIqjEvXLIXw+hZV9OihtAq66iwQgupKMtBIk2iTLpBc9l1c0lI6BuMPOmfvUwlYkycVnbAUa0e9+kK2t+wIDAQAB';


export const GROUP_TYPE_OPT = [
    {
        value: '0',
        name: 'labelTitlePermanentGroup',
    },
    {
        value: '1',
        name: 'labelTitleTemporaryGroup',
    },
];
